import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp, FaArrowUp } from "react-icons/fa";
import { COMPANY } from "../data/content";

const FloatingActions = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 400);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            {/* WhatsApp FAB */}
            <a
                href={`https://wa.me/${COMPANY.phoneDigits}?text=${encodeURIComponent(COMPANY.whatsappMsg)}`}
                target="_blank" rel="noopener noreferrer"
                data-testid="whatsapp-fab"
                className="fixed bottom-6 right-6 z-40 group"
                aria-label="WhatsApp us"
            >
                <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring" />
                <span className="absolute inset-0 rounded-full bg-emerald-500 animate-pulse-ring" style={{ animationDelay: "0.6s" }} />
                <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-2xl shadow-xl shadow-emerald-500/40 transition">
                    <FaWhatsapp />
                </span>
            </a>

            {/* Scroll to Top */}
            <AnimatePresence>
                {show && (
                    <motion.button
                        data-testid="scroll-top-btn"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.5 }}
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="fixed bottom-6 left-6 z-40 flex items-center justify-center w-12 h-12 rounded-full bg-brand-700 hover:bg-brand-800 text-white shadow-xl transition"
                        aria-label="Scroll to top"
                    >
                        <FaArrowUp />
                    </motion.button>
                )}
            </AnimatePresence>
        </>
    );
};

export default FloatingActions;
